import { MapPin, CheckCircle2 } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const REGIONS = [
  "Nyugat-Magyarország",
  "Dunántúl több megyéje",
  "Pest megye",
  "Szlovákia területe",
];

export default function ServiceArea() {
  return (
    <section data-testid="service-area-section" className="bg-white py-16 sm:py-20 md:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 px-5 md:px-10 items-center">
        <div>
          <Reveal><Overline>Működési terület</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 text-4xl sm:text-5xl font-bold tracking-tight text-[#0E5A75] text-balance">
              Hol vállalunk tetőfedési munkákat?
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed">
              Tetőfedési, tetőjavítási, tetőfelújítási, bádogos és tetőszigetelési munkákat vállalunk
              Nyugat-Magyarországon, a Dunántúl több megyéjében, Pest megyében, valamint Szlovákia
              területén. A pontos helyszínnel és a kivitelezési lehetőségekkel kapcsolatban kérjen
              egyedi tájékoztatást.
            </p>
          </Reveal>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {REGIONS.map((r, i) => (
              <Reveal key={r} delay={0.12 + i * 0.06}>
                <div className="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3.5">
                  <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-500" />
                  <span className="font-medium text-[#0E5A75]">{r}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.15}>
          <div className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-gradient-to-br from-[#0E5A75] to-[#0B4A60] shadow-xl aspect-[4/3]">
            <div className="absolute inset-0 noise-overlay opacity-[0.12]" />

            {/* coverage radar rings */}
            <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="h-[420px] w-[420px] rounded-full border border-white/10" />
              <div className="absolute inset-0 m-auto h-72 w-72 rounded-full border border-white/10" />
              <div className="absolute inset-0 m-auto h-40 w-40 rounded-full border border-emerald-400/30" />
            </div>
            {/* floating region pins */}
            <span className="absolute left-[22%] top-[30%] h-2.5 w-2.5 rounded-full bg-emerald-400 shadow-[0_0_0_4px_rgba(174,206,47,0.2)]" />
            <span className="absolute right-[24%] top-[38%] h-2.5 w-2.5 rounded-full bg-[#38A8CE] shadow-[0_0_0_4px_rgba(56,168,206,0.2)]" />
            <span className="absolute left-[34%] bottom-[26%] h-2.5 w-2.5 rounded-full bg-white/70" />

            <div className="absolute left-5 top-5 flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white backdrop-blur">
              <MapPin className="h-4 w-4 text-emerald-400" /> Központ: Győr
            </div>

            <div className="relative flex h-full flex-col items-center justify-center px-8 text-center">
              <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-emerald-400 text-[#0E5A75] shadow-lg animate-soft-float">
                <MapPin className="h-8 w-8" />
              </span>
              <div className="mt-6 text-4xl font-extrabold tracking-tight text-white">
                HU <span className="text-emerald-400">·</span> SK
              </div>
              <p className="mt-3 max-w-xs text-slate-300">
                Nyugat-Magyarország, Dunántúl, Pest megye és Szlovákia területén dolgozunk.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
